import DataService from '@/service/DataService'

const state = {
  status: {},
  sigfox: [],
  allSigfox: []
}

const getters = {
  sigfoxStatus: (state) => state.status,
  sigfox: (state) => state.sigfox,
  allSigfox: (state) => state.allSigfox
};

const actions = {
  // GET
  fetchSigfoxData( { commit }, deviceId) {
    commit('GETSIGFOXDATAREQUEST')

    return DataService.getSigfoxLastDevicePosition(deviceId)
      .then(res => {
        commit('GETSIGFOXDATASUCCESS', res.data)
        if (res.data.geraet) {
          commit('UPDATEGERAETFROMSIGFOX', res.data.geraet)
        }
      })
      .catch(err => {
        commit('GETSIGFOXDATAFAILURE', err)
      })
  },
  fetchSigfoxDataById( { commit }) {
    commit('GETSIGFOXDATABYIDREQUEST')

    return DataService.getSigfoxDataById()
      .then(res => {
        commit('GETSIGFOXDATABYIDSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETSIGFOXDATABYIDFAILURE', err)
      })
  },
  fetchAllSigfoxData( { commit }) {
    commit('GETALLSIGFOXDATAREQUEST')

    return DataService.getAllSigfoxData()
      .then(res => {
        commit('GETALLSIGFOXDATASUCCESS', res.data)
      })
      .catch(err => {
        commit('GETALLSIGFOXDATAFAILURE', err)
      })
  },

  // POST
  decodeSigfoxMessage( { commit }, message) {
    commit('DECODESIGFOXMESSAGEREQUEST')

    return DataService.postDecodeSigfoxMessage(message)
      .then(res => {
        commit('DECODESIGFOXMESSAGESUCCESS')
        return res.data
      })
      .catch(err => {
        commit('DECODESIGFOXMESSAGEFAILURE', err)
      })
  }
};

const mutations = {
  // GET
  GETSIGFOXDATAREQUEST: (state) => {state.status = { gettingSigfoxData: true }},
  GETSIGFOXDATASUCCESS: (state, res) => {
    if (res.msg) {
      state.status = { msg: res.msg}
    }
    else {
      state.status = {}
      state.sigfox[res.position.device] = res.position
    }
  },
  GETSIGFOXDATAFAILURE: (state, err) => {state.status = {errMsg: err}},
  GETSIGFOXDATABYIDREQUEST: (state) => {state.status = { gettingSigfoxDataById: true }},
  GETSIGFOXDATABYIDSUCCESS: (state, res) => {
    state.status = {}
    res.forEach(sigfoxData => state.sigfox[sigfoxData.device] = sigfoxData)
    
  },
  GETSIGFOXDATABYIDFAILURE: (state, err) => {state.status = {errMsg: err}},
  GETALLSIGFOXDATAREQUEST: (state) => {state.status = { gettingAllSigfoxData: true }},
  GETALLSIGFOXDATASUCCESS: (state, res) => {
    state.status = {}
    state.allSigfox = res
  },
  GETALLSIGFOXDATAFAILURE: (state, err) => {state.status = {errMsg: err}},

  // POST
  DECODESIGFOXMESSAGEREQUEST: (state) => {state.status = { decodingSigfoxMessage: true }},
  DECODESIGFOXMESSAGESUCCESS: (state) => {
    state.status = {}
  },
  DECODESIGFOXMESSAGEFAILURE: (state, err) => {state.status = {errMsg: err}}
};

export default {
  state,
  getters,
  actions,
  mutations
}